// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "flowbite"

// Turbo replaces the head but retains the html element between visits.
document.addEventListener("turbo:load", () => {
  document.documentElement.dataset.theme = document.querySelector('meta[name="platform-theme"]')?.content || "citrus"
  const zone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const previous = document.cookie.split("; ").find(value => value.startsWith("browser_time_zone="))?.split("=").slice(1).join("=")
  if (zone && previous !== encodeURIComponent(zone)) {
    document.cookie = `browser_time_zone=${encodeURIComponent(zone)}; Path=/; Max-Age=31536000; SameSite=Lax`
    // Reload once so the first server-rendered page uses the detected timezone.
    if (document.cookie.includes(`browser_time_zone=${encodeURIComponent(zone)}`) && !document.querySelector('[data-controller~="logo-intro"]')) window.location.reload()
  }
})
